import { Component, Inject, OnInit, Optional } from '@angular/core';
import { IzvjestajDownloadService } from '@app/components';
import { AppConfig, appConfigService } from '@app/config';
import { DynamicFormService } from '@ntap/common';
import {
  ActionTarget,
  DataSource,
  ItemProvider,
  ListView,
  ListViewProviderDirective,
  NotificationService,
  ServerItemAction,
  ViewWindow
} from '@ntap/core';
import { combineLatest, first, map, switchMap, take } from 'rxjs';

@Component({
  selector: 'app-print-label-dostava-pdf-action',
  templateUrl: '../../../shared/components/actions/common-action-template.html'
})
export class PrintLabelDostavaPdfActionComponent
  extends ServerItemAction
  implements OnInit
{
  protected pathReportPreviewPdf: string;

  constructor(
    protected override notificationService: NotificationService,
    @Optional() protected override itemProvider: ItemProvider,
    protected override dataSource: DataSource,
    @Optional() protected dynamicFormService: DynamicFormService,
    @Optional()
    protected override listViewProvider: ListViewProviderDirective<ListView>,
    protected izvjestajDownloadService: IzvjestajDownloadService,
    @Optional() protected override window: ViewWindow,
    @Inject(appConfigService) private config: AppConfig
  ) {
    super(notificationService, itemProvider, dataSource, listViewProvider);
    this.config = config;
  }

  private baseUrl = this.config.apiHost;

  ngOnInit(): void {
    this.action.description = 'Ispiši adresu';
    this.action.icon = 'download';
  }

  protected override initDisabledObservable(): void {
    this.isDisabled$ = this.listViewProvider.selectedItems$.pipe(
      map((selected) => {
        return (
          this.action.target !== ActionTarget.ITEM_DIALOG &&
          selected.length === 0
        );
      })
    );
  }

  override execute(): void {
    combineLatest([
      this.itemProvider.item$.pipe(first()),
      this.listViewProvider.selectedItems$.pipe(first())
    ])
      .pipe(
        take(1),
        map(([item, selectedItems]) => {
          const dostavaIdList =
            this.action.target !== ActionTarget.ITEM_DIALOG &&
            selectedItems &&
            selectedItems.length > 0
              ? selectedItems.map((e: any) => e['seup~dostava~id'])
              : [(item as any)['seup~dostava~id']];
          const payload = {
            format: 'pdf',
            reportParams: {
              dostava_id: dostavaIdList
            }
          };
          return payload;
        }),
        switchMap((payload) => this.doDownload(payload))
      )
      .subscribe();
  }

  private doDownload(body: any) {
    const url = `${this.baseUrl}print-label/otpreme`;
    return this.izvjestajDownloadService.previewReportByUrl(url, body);
  }
}
